import React from 'react';
import { canAdjustSnookerReds } from '../utils/snookerScoring';
import './SnookerRedsControls.css';

export default function SnookerRedsControls({ gameState, adjustReds }) {
    const clearanceStarted = gameState.redsRemaining === 0
        && Object.values(gameState.colorsPottedFirstTime || {}).some(Boolean);
    return (
        <section className="snooker-reds-controls" aria-label="Reds on table">
            <div className="snooker-reds-heading">
                <span className="snooker-reds-dot" aria-hidden="true" />
                <h3>Reds on table</h3>
                <output aria-label="Reds remaining" aria-live="polite">{gameState.redsRemaining}</output>
            </div>
            <div className="snooker-reds-buttons">
                <button type="button" disabled={!canAdjustSnookerReds(gameState, -1)} onClick={() => adjustReds(-1)}>Remove red (−1)</button>
                <button type="button" disabled={!canAdjustSnookerReds(gameState, 1)} onClick={() => adjustReds(1)}>Add red (+1)</button>
            </div>
            <p>Count correction only — no points. Record foul points separately. Use Undo to reverse a correction.</p>
            {clearanceStarted && <p>To restore reds, Undo the colour-clearance pots first.</p>}
        </section>
    );
}
